import React, { useEffect, useState } from 'react'
import PrivateLayout from '../../layouts/privateLayout'
import DataSteps from './listing'
import OnboardingStepper from '../Homepage/onBoardingStepper'
import { useApiClient } from "../../context/ApiClientContext";
import toast from "react-hot-toast";
import {
  Box,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Check } from "@mui/icons-material";
import api from "../../helper/baseApi";
import BasicBreadcrumbs from '../../components/breadcrumb';


const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};


const Index = () => {

  const [showOnboarding, setShowOnboarding] = useState('');
  const userId = localStorage.getItem('employeeId');
  const {
    apiUrls: { mobileApiUrl },
  } = useApiClient();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    accountSetup: localStorage.getItem("employeeId"),
    gender: "",
    dob: "",
    valueTags: [],
    identity: "",
    employeeDb: "",
  });

 useEffect(() => {
    fetchData();
  }, [mobileApiUrl]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const apiUrl = `${mobileApiUrl}onboarding/onboarding-list`;
      const res = await api.get(apiUrl);

      const { dateOfBirth, gender, valuetagName, emailGreeting, addedEmployee } =
        res.data.data || {};

      setData({
        accountSetup: localStorage.getItem("employeeId") || "",
        gender: gender || "",
        dob: formatDate(dateOfBirth),
        valueTags:
          valuetagName?.map((tag) => ({
            label: tag,
            description: "",
          })) || [],
        identity: emailGreeting || "",
        employeeDb: Boolean(addedEmployee),
      });

      const isFirstTime = localStorage.getItem("isFirstTime");
      console.log("isFirstTime", isFirstTime);

      setShowOnboarding(isFirstTime !== "false"); // simpler logic
    } catch (error) {
      console.error("Error fetching data:", error.message);
      toast.error("Error fetching data: " + error.message, {
        style: { zIndex: 9999 },
      });
    } finally {
      setLoading(false); // ⬅️ Always stop loading
    }
  };

  const steps = [
    {
      number: 1,
      title: "Account Setup",
      value: data.accountSetup,
      render: (value) =>
        value ? (
          <Typography variant="body">
            Your POISUM account is ready. You've taken the first step toward building an engaged and motivated team.
          </Typography>
        ) : (
          <>Click <Link to="/">here</Link> to create your Poisum account.</>
        ),
    },
    {
      number: 2,
      title: "Little about you",
      value: { gender: data.gender, dob: data.dob },
      render: (value) =>
        value.gender || value.dob ? (
          <Box>
            <Typography variant="body">
              You have added your personal details — now your POISUM is ready to
              connect with your team.
            </Typography>
            {value.gender && (
              <Typography variant="body" display="block">
                <strong>Gender</strong> – {value.gender }
              </Typography>
            )}
            {value.dob && (
              <Typography variant="body" display="block">
                <strong>DOB</strong> – {value.dob}
              </Typography>
            )}
          </Box>
        ) : (
          <>Click <Link to="/account">here</Link> to add your personal details.</>
        ),
    },
    {
      number: 3,
      title: "The value tag",
      value: data.valueTags,
      render: (value) =>
        value.length ? (
          <Box>
            <Typography variant="body" gutterBottom>
              Great job! You have set the core values that will guide missions
              and rewards for your team.
            </Typography>
            {value.map((tag, index) => (
              <Typography key={index} variant="body" display="block">
                <strong>{tag.label}</strong>
              </Typography>
            ))}
          </Box>
        ) : (
          <>Click <Link to="/value-tag">here</Link> to add value tags.</>
        ),
    },
    {
      number: 4,
      title: "Team Identity",
      value: data.identity,
      render: (value) =>
        value ? (
          <Typography variant="body">
            Your team now is <strong>{value}</strong>, a unique name that
            represents your culture and spirit in POISUM.
          </Typography>
        ) : (
          <Typography variant="body">
            Click <Link to="/account">here</Link> to create your Poisum name.
          </Typography>
        ),
    },
    {
      number: 5,
      title: "Employee Database",
      value: data.employeeDb,
      render: (value) =>
        value ? (
          <Typography variant="body">
            Your employee data is uploaded and your team is ready to join in missions, earn points, and celebrate success.
          </Typography>
        ) : (
          <Typography variant="body">
            Click <Link to="/user">here</Link> to upload the datasheet.
          </Typography>
        ),
    },
  ];

  return (
     <PrivateLayout>
    <Box sx={{ mx: "40px", mt: 5 }}>
 <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
          }}
        >
          <BasicBreadcrumbs first="Welcome to Poisum" />
        </Box>

      <Typography variant="body" >
        To get started, please set up your organization’s data by following these steps:
      </Typography>
    </Box>
        <DataSteps steps={steps} loading={loading} />
         {showOnboarding && ( <OnboardingStepper open= {showOnboarding} onClose={() => setShowOnboarding(false)} fetchData={fetchData} />)}
    </PrivateLayout>
  )
}

export default Index;